import { useState } from 'react';

import { useGetNecessaryData } from '../../../../shared/hooks/useGetNecessaryData';
import { FOOD_TYPE, FoodType } from '../../../constants/foodType';
import { foodsService } from '../../../services/foodsService';
import { foodTemplateStorage } from '../../../utils';
import { FoodFormInitialData } from '../interfaces/FoodFormInitialData';
import { getFoodFormData } from '../utils/getFoodFormData/getFoodFormData';
import { withSupplementTag } from '../utils/withSupplementTag/withSupplementTag';

type UseFoodFormInitialValuesParams = {
  foodType: FoodType;
  isEdit: boolean;
  foodId?: number;
  templateId?: string;
};

/** null until every dictionary and the initial values have loaded */
export const useFoodFormInitialValues = ({
  foodType,
  foodId,
  templateId,
  isEdit,
}: UseFoodFormInitialValuesParams) => {
  const [initialData, setInitialData] = useState<FoodFormInitialData | null>(null);

  useGetNecessaryData(async () => {
    const isSupplement = foodType === FOOD_TYPE.SUPPLEMENT;
    const template = templateId ? foodTemplateStorage.get(templateId) : null;

    if (isEdit && !foodId) {
      throw new Error('Food not found');
    }

    const [tags, microNutrientOptions, dbMeasurements, brands, food] = await Promise.all([
      foodsService.getAllTags(),
      foodsService.getAllMicroNutrients(),
      foodsService.getMeasurements(),
      isSupplement ? foodsService.getBrands() : [],
      foodId ? foodsService.getFood(foodId) : null,
    ]);

    const data = getFoodFormData(food ?? template, dbMeasurements);

    if (isSupplement && !isEdit) {
      data.defaultValues.tags = withSupplementTag(data.defaultValues.tags, tags);
    }

    setInitialData({ ...data, tags, microNutrientOptions, brands, food });
  }, [foodType, foodId, templateId]);

  return initialData;
};
